export { default as listModelDetailSlice } from './listModelDetailSlice'
export { default as createModelDetailSlice } from './createModelDetailSlice'
export { default as updateModelDetailSlice } from './updateModelDetailSlice'
export { default as showModelDetailSlice } from './showModelDetailSlice'
export { default as deleteModelDetailSlice } from './deleteModelDetailSlice'
